import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'displayNumber',
    standalone: false
})
export class DisplayNumberPipe implements PipeTransform {
    transform(subject: any, addBrackets?: boolean): string {
        if (!subject) {
            return ''
        }

        //pro SJM subjekty, ktere nemaji udaje u sebe
        //je nutne vzit udaje z contact atributu
        if (subject.opsubType === 'SJM' && subject.contact) {
            subject = subject.contact
        }

        if (subject.identCely) {
            return subject.identCely
        }

        let ret = ''

        if (subject.opsubType === 'OFO' || subject.opsubType === 'SJM' || subject.rodneCislo) { // data from CUZK does not have opsubType in some cases, but it has ico or rodneCislo
            let rc = subject.rodneCislo ? subject.rodneCislo : 'neuvedeno'
            if (subject.identCely) {
                rc = subject.identCely
            }
            ret = 'r.č.:' + String.fromCharCode(160) + rc
        }

        if (subject.opsubType === 'OPO' || subject.ico) {
            let ic = subject.ico ? subject.ico : 'neuvedeno'
            if (subject.identCely) {
                ic = subject.identCely
            }
            ret = 'IČ:' + String.fromCharCode(160) + ic
        }

        return addBrackets ? '(' + ret + ')' : ret
    }
}